import get from 'lodash/get';
import { useCreateDispatches } from 'helpers/hooks';
import * as service from 'services';

export function useGetVaultActivity({
	setActivity,
	setLastVaultFileActivityId,
} = {}) {
	const { setSnackbar } = useCreateDispatches();

	const params = {
		callback: service.getVaultActivity,
		dataPath: `data.vaultFileActivities`,
	};

	if (!params || !params.callback) return () => Promise.resolve(null);

	return async ({ childId, lastVaultFileActivityId } = {}) => {
		return await service
			.getVaultActivity({ childId }, lastVaultFileActivityId)
			.then((result) => {
				setActivity?.(get(result, params.dataPath));
				setLastVaultFileActivityId?.(
					get(result, 'data.lastVaultFileActivityId') || null
				);
				return result;
			})
			.catch((err) => {
				setActivity([]);
				setSnackbar(
					{
						variant: 'error',
						message:
							err.response?.data?.message ||
							'Something went wrong. Please try again later',
					},
					{ log: true }
				);
			});
	};
}
